import {useState, useEffect} from "preact/compat";

export const useBreadcrumbs = props => {
    // Destructured props
    const {
        categoryServiceType,
        productName
    } = props;

    // State to store the formatted data.
    // It already contains the first item, which will always be the home item.
    // It also serves as an example for the data model to be used.
    const [formattedData, setFormattedData] = useState([]);
    // Flags when component is ready to be rendered
    const [isReady, setIsReady] = useState(false);

    // This is the method responsible for formatting the data
    // after it has been provided to this controller
    const formatData = () => {
        let breadcrumbs = [{
            label: "Início"
        }];

        if (categoryServiceType) {
            // Merges the initial data with the category service type
            breadcrumbs.push({
                label: categoryServiceType
            });
        }

        if (productName) {
            // Merges the initial data with the product name
            breadcrumbs.push({
                label: productName
            });
        }

        setFormattedData(breadcrumbs);

        // Only renders if category service type or product name exists
        const shouldRender = breadcrumbs.length > 1;

        // Flags that the content is ready to be rendered
        setIsReady(shouldRender);
    }

    // Effect to call the format data on page load
    useEffect(() => {
        formatData();
    }, [
        categoryServiceType,
        productName
    ]);

    return {
        formattedData,
        isReady
    }
}
